module.exports = __webpack_public_path__ + "img/audio-off.224752b5.svg";